module.exports = __webpack_public_path__ + "img/top-image.8f370a16.png";